import { useState } from 'react';
import { formatRepairNumber } from '../utils/format';

const API_BASE = 'https://vhnsv33dvk.execute-api.eu-west-1.amazonaws.com';

const STATUS_LABELS = {
  initial_inspection:  'Received – awaiting inspection',
  estimate_pending:    'Being assessed',
  estimate_sent:       'Estimate provided – awaiting your approval',
  estimate_approved:   'Estimate approved – work will commence shortly',
  waiting_parts:       'Approved – awaiting parts',
  in_progress:         'In progress',
  on_test:             'Repair complete – on test',
  completed:           'Ready for collection',
  collected:           'Collected',
  cancelled:           'Cancelled',
  returned:            'Returned to workshop',
  return_in_progress:  'Being reviewed following return',
  no_repair:           'Unable to repair – please collect'
};

const ITEM_LABELS = {
  watch:      'Watch',
  clock:      'Clock',
  jewellery:  'Jewellery',
  other:      'Item'
};

function CustomerStatus() {
  const [repairNumber, setRepairNumber] = useState('');
  const [postcode, setPostcode] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResult(null);
    setError(null);
    setLoading(true);

    try {
      const response = await fetch(
        `${API_BASE}/status?repair_number=${encodeURIComponent(repairNumber)}&postcode=${encodeURIComponent(postcode)}`
      );
      const data = await response.json();

      if (response.ok) {
        setResult(data);
      } else if (response.status === 404) {
        setError('No repair found matching these details. Please check your repair number and postcode.');
      } else if (response.status === 400) {
        setError('Please enter a valid repair number and postcode.');
      } else {
        setError('Something went wrong. Please try again.');
      }
    } catch (err) {
      setError('Unable to connect. Please check your internet connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="app-header">
        <h1>Repair Status</h1>
        <p>Check the current status of your repair</p>
      </header>

      <main className="app-main">
        <form className="lookup-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="repairNumber">Repair Number</label>
            <input
              id="repairNumber"
              type="text"
              value={repairNumber}
              onChange={(e) => setRepairNumber(e.target.value)}
              placeholder="e.g. 1001"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="postcode">Postcode</label>
            <input
              id="postcode"
              type="text"
              value={postcode}
              onChange={(e) => setPostcode(e.target.value)}
              placeholder="e.g. NN13 7DZ"
              required
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? 'Checking...' : 'Check Status'}
          </button>
        </form>

        {error && (
          <div className="result-card error">
            <p>{error}</p>
          </div>
        )}

        {result && (
          <div className="result-card success">
            <h2>Repair #{formatRepairNumber(result.repair_number)}</h2>
            <div className="result-row">
              <span className="result-label">Item</span>
              <span className="result-value">{ITEM_LABELS[result.item_type] || result.item_type}</span>
            </div>
            <div className="result-row">
              <span className="result-label">Status</span>
              <span className="result-value">{STATUS_LABELS[result.status] || result.status}</span>
            </div>
            {result.final_amount && (
              <div className="result-row">
                <span className="result-label">Amount Due</span>
                <span className="result-value">
                  {new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(result.final_amount)}
                </span>
              </div>
            )}
          </div>
        )}
        <div className="staff-login">
          <a href="/admin/login">Staff login</a>
        </div>
      </main>
    </div>
  );
}

export default CustomerStatus;